<template>
<div class="explore-list">
    <div class="explore-title">{{ $t('poi.hotAround') }}</div>
    <div class="explore-tabs">
        <div class="tab" :class="{'active': index === active}"
              v-for="(item, index) in tabs"
              :key="item.id"
              @click="handleChangeTab(index)">{{ item.name }}
        </div>
    </div>
    <!--景点-->
    <div v-show="active === 0">
        <div class="list">
            <div class="item"
                  v-for="(item, index) in sites"
                  :key="item.id"
                  @click="handleDetail('site', index)">
                <div class="item-img">
                    <img class="explore-img" v-lazy="generateObj(item.images || '/image/default_img.jpg')"/>
                    <img v-if="siteId !== '129'" src="@/assets/scenic/sentosa-wave-orange.svg" class="wave"/>
                </div>
                <div class="item-detail">
                    <div class="name">{{ item.name }}</div>
                    <div class="info">
                        <div class="price" v-if="item.ticket_type === 'supported'">
                            <div class="price-icon" v-if="item.best_price!==null && $i18n.locale === 'en'">From&nbsp;</div>
                            <div class="price-text" v-if="item.best_price!==null">{{ $t('common.symbol') }}{{ item.best_price / 100}}</div>
                            <div class="price-icon" v-if="item.best_price!==null && $i18n.locale === 'zh'">起</div>
                        </div>
                        <div class="price" v-else-if="item.ticket_type==='unsupported'">
                            <div class="price-icon" v-if="item.low_price!==null && $i18n.locale === 'en'">From&nbsp;</div>
                            <div class="price-text" v-if="item.low_price!==null">{{ $t('common.symbol') }}{{ item.low_price / 100 }}</div>
                            <div class="price-icon" v-if="item.low_price!==null && $i18n.locale === 'zh'">起</div>
                        </div>
                        <!--v-if="{{item.ticket_type==='free'}}"-->
                        <div class="price" v-else>
                            <div class="price-text">{{ $t('home.free') }}</div>
                        </div>
                        <div class="place-rate" v-if="item.rating">
                            <v-score :rating="item.rating"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--酒店-->
    <div v-show="active === 1">
        <div class="list">
            <div class="item"
                  v-for="(item, index) in hotels"
                  :key="item.id"
                  @click="handleDetail('hotel', index)">
                <div class="item-img">
                    <img class="explore-img" v-lazy="generateObj(item.images)"/>
                    <img v-if="siteId !== '129'" src="@/assets/scenic/sentosa-wave-orange.svg" class="wave"/>
                </div>
                <div class="item-detail">
                    <div class="name">{{ item.name }}</div>
                    <div class="info">
                        <div class="price" v-if="item.best_price">
                            <div class="price-icon" v-if="$i18n.locale === 'en'">From&nbsp;</div>
                            <div class="price-text">{{ $t('common.symbol') }}{{ item.best_price }}</div>
                            <div class="price-icon" v-if="$i18n.locale === 'zh'">起</div>
                        </div>
                        <div class="price" v-else-if="item.best_price === 0">
                            <div class="price-text">{{ $t('home.free') }}</div>
                        </div>
                        <div class="price" v-else></div>
                        <div class="place-rate" v-if="item.rating">
                            <v-score :rating="item.rating"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--美食-->
    <div v-show="active === 2">
        <div class="list">
            <div class="item"
                  v-for="(item, index) in merchants"
                  :key="item.id"
                  @click="handleDetail('merchant', index)">
                <div class="item-img">
                    <img class="explore-img" v-lazy="generateObj(item.images)"/>
                    <img v-if="siteId !== '129'" src="@/assets/scenic/sentosa-wave-orange.svg" class="wave"/>
                </div>
                <div class="item-detail">
                    <div class="name">{{ item.name }}</div>
                    <div class="info">
                        <div class="price" v-if="item.best_price">
                            <div class="price-icon" v-if="$i18n.locale === 'en'">From&nbsp;</div>
                            <div class="price-text">{{ $t('common.symbol') }}{{ item.best_price / 100 }}</div>
                            <div class="price-icon" v-if="$i18n.locale === 'zh'">起</div>
                        </div>
                        <div class="price" v-else-if="item.best_price === 0">
                            <div class="price-text">{{ $t('home.free') }}</div>
                        </div>
                        <div class="price" v-else></div>
                        <div class="place-rate" v-if="item.rating">
                            <v-score :rating="item.rating"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Score from '@/components/Score.vue'

export default {
    data () {
        return {
            siteId: '1',
            active: 0,
            appName: app.appName,
            tabs: [
                { name: this.$t('poi.site'), id: 1 },
                { name: this.$t('poi.hotel'), id: 2 },
                { name: this.$t('poi.merchant'), id: 3 }
            ]
        }
    },
    components: {
        'v-score': Score
    },
    props: {
        sites: {
            type: Array,
            default: () => {
                return []
            }
        },
        hotels: {
            type: Array,
            default: () => {
                return []
            }
        },
        merchants: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    methods: {
        generateObj (src) {
            return {
                src,
                error: '/image/default_img.jpg',
                loading: '/image/loading-img.jpg'
            }
        },
        handleChangeTab (index) {
            this.active = index
        },
        handleDetail (type, index) {
            let url = ''
            if (type === 'site') {
                const id = this.sites[index].id
                url = `/siteDetail/${id}`
            } else if (type === 'hotel') {
                const id = this.hotels[index].id
                url = `/hotelDetail/${id}`
            } else {
                const id = this.merchants[index].id
                url = `/merchantDetail/${id}`
            }
            if (this.$route.query.language === 'zh') url += '?language=zh'
            this.$router.push(url)
        }
    }
}
</script>

<style lang="scss" scoped>
.explore-title {
    font-size: 18px;
    font-weight: bold;
    font-family: GothamBold;
    color: #222215;
    margin-bottom: 12px;
}

.explore-tabs {
    display: flex;
}

.explore-tabs .tab {
    padding: 0 19px;
    height: 26px;
    border-radius: 13px;
    border: solid 1px #efefef;
    font-size: 14px;
    color: #666666;
    display: flex;
    align-items: center;
    justify-content: center;
}

.explore-tabs .tab:not(:last-child) {
    margin-right: 11px;
}

.explore-tabs .tab.active {
    background-color: #f8a909;
    border-color: #f8a909;
    color: #ffffff;
}

.explore-list .list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 13px;
}

.explore-list .item {
    width: 170px;
    position: relative;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
    margin-top: 11px;
}

.explore-list .explore-img {
    width: 100%;
    height: 107px;
}

.explore-list .wave {
    position: absolute;
    top: 102px;
    left: 0;
    width: 100%;
    height: 10px;
}

.explore-list .item-detail {
    padding: 6px 11px 7px;
}

.item-detail .name {
    font-size: 14px;
    font-weight: bold;
    font-family: GothamBold;
    line-height: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #333333;
    margin-bottom: 7px;
}

.item-detail .info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 17px;
}

.item-detail .info .price {
    display: flex;
    align-items: baseline;
    color: #60c2ed;
}

.item-detail .info .price-text {
    font-size: 12px;
}

.item-detail .info .price-icon {
    font-size: 9px;
}

.place-rate {
    display: flex;
    align-items: center;
}

</style>